<template>
    <div class="cooperation-manage">
        <div class="search-section">
            <div class="search-fields">
                <el-input v-model="query.unitName" placeholder="🔍 请输入单位名称" style="width:180px" clearable
                    @keyup.enter.native="loadPost"></el-input>
                <el-input v-model="query.contactPerson" placeholder="🔍 请输入联系人" style="width:160px;margin-left:6px" clearable
                    @keyup.enter.native="loadPost"></el-input>
                <el-input v-model="query.itemName" placeholder="🔍 请输入物品名称" style="width:160px;margin-left:6px" clearable
                    @keyup.enter.native="loadPost"></el-input>
                <el-button type="primary" class="action-btn" @click="loadPost">查询</el-button>
                <el-button class="action-btn" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
            </div>
            <div class="action-buttons">
                <el-button type="success" icon="el-icon-plus" class="action-btn" @click="openDialog()">新增合作商</el-button>
            </div>
        </div>

        <el-table 
            :data="tableData" 
            border 
            stripe 
            :header-cell-style="{ background: '#f8f9fc', color: '#2c3e50', fontWeight: 600, fontSize: '14px' }"
            style="width: 100%; border-radius: 12px; box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);"
            highlight-current-row
            show-overflow-tooltip>
            <el-table-column type="index" label="序号" width="70" align="center"></el-table-column>
            <el-table-column prop="itemName" label="物品名称" width="140" align="center">
                <template slot-scope="scope"><span>{{ scope.row.itemName || '/' }}</span></template>
            </el-table-column>
            <el-table-column prop="unitName" label="单位名称" width="180" align="center"></el-table-column>
            <el-table-column prop="contactPerson" label="联系人" width="120" align="center">
                <template slot-scope="scope"><span>{{ scope.row.contactPerson || '/' }}</span></template>
            </el-table-column>
            <el-table-column prop="post" label="职务" width="110" align="center">
                <template slot-scope="scope"><span>{{ scope.row.post || '/' }}</span></template>
            </el-table-column>
            <el-table-column prop="phone" label="电话" width="140" align="center">
                <template slot-scope="scope"><span>{{ scope.row.phone || '/' }}</span></template>
            </el-table-column>
            <el-table-column prop="wechat" label="微信号" width="140" align="center">
                <template slot-scope="scope"><span>{{ scope.row.wechat || '/' }}</span></template>
            </el-table-column>
            <el-table-column prop="cooperationMatters" label="合作事项" align="center"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="180" align="center"></el-table-column>
            <el-table-column label="操作" width="200" fixed="right" align="center">
                <template slot-scope="scope">
                    <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-edit"
                        plain
                        @click="openDialog(scope.row)"
                        style="border-radius: 15px; padding: 1px 8px; font-size: 12px;"
                    >编辑</el-button>
                    <el-popconfirm title="确定删除该合作商吗？" @confirm="handleDelete(scope.row.id)">
                        <el-button
                            slot="reference"
                            type="danger"
                            size="mini"
                            icon="el-icon-delete"
                            plain
                            style="border-radius: 15px; padding: 1px 8px; font-size: 12px;"
                        >删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-wrapper">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
                :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total,sizes,prev,pager,next,jumper"
                :total="total" background>
            </el-pagination>
        </div>

        <!--新增编辑弹窗-->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="650px" append-to-body top="5vh" center :close-on-click-modal="false">
            <el-form ref="formRef" :model="form" label-width="110px">
                <el-form-item label="物品名称" prop="itemId">
                    <el-select
                        v-model="form.itemId"
                        placeholder="请从物品信息选择（可输入搜索）"
                        style="width:100%"
                        filterable
                        remote
                        clearable
                        :loading="goodsLoading"
                        :remote-method="remoteGoodsSearch"
                        @change="handleItemChange"
                    >
                        <el-option
                            v-for="item in itemOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="单位名称">
                    <el-input v-model="form.unitName"></el-input>
                </el-form-item>
                <el-form-item label="联系人">
                    <el-input v-model="form.contactPerson"></el-input>
                </el-form-item>
                <el-form-item label="职务">
                    <el-input v-model="form.post"></el-input>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input v-model="form.phone"></el-input>
                </el-form-item>
                <el-form-item label="微信号">
                    <el-input v-model="form.wechat"></el-input>
                </el-form-item>
                <el-form-item label="合作事项">
                    <el-input v-model="form.cooperationMatters" type="textarea" rows="4"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm">确定保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "Cooperation",
    data() {
        return {
            tableData: [],
            pageNum: 1,
            pageSize: 10,
            total: 0,
            query: {
                unitName: "",
                contactPerson: "",
                itemName: ""
            },
            dialogVisible: false,
            dialogTitle: "新增合作商",
            form: {
                id: null,
                itemId: "",
                itemName: "",
                unitName: "",
                contactPerson: "",
                post: "",
                phone: "",
                wechat: "",
                cooperationMatters: ""
            },
            itemOptions: [],
            goodsLoading: false
        }
    },
    methods: {
        loadPost() {
            this.$axios.post(this.$httpUrl + "/cooperation/listPage", {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                param: { ...this.query }
            }).then(res => res.data).then(res => {
                if (res.code === 200) {
                    this.tableData = res.data;
                    this.total = res.total;
                }
            })
        },
        // 加载物品列表（复用goods/listPage接口）
        loadGoodsList(keyword = "") {
            this.goodsLoading = true;
            this.$axios.post(this.$httpUrl + "/goods/listPage", {
                pageNum: 1,
                pageSize: 9999,
                param: {
                    name: keyword,
                    deleted: 0
                }
            }).then(res => res.data).then(res => {
                if (res.code === 200) {
                    this.itemOptions = res.data;
                }
            }).finally(() => {
                this.goodsLoading = false;
            })
        },
        remoteGoodsSearch(keyword) {
            this.loadGoodsList(keyword);
        },
        resetQuery() {
            this.query = { unitName: "", contactPerson: "", itemName: "" };
            this.pageNum = 1;
            this.loadPost();
        },
        handleSizeChange(val) {
            this.pageNum = 1;
            this.pageSize = val;
            this.loadPost();
        },
        handleCurrentChange(val) {
            this.pageNum = val;
            this.loadPost();
        },
        openDialog(row) {
            this.dialogVisible = true;
            this.loadGoodsList();
            this.$nextTick(() => {
                if (this.$refs.formRef) {
                    this.$refs.formRef.resetFields();
                }
                if (row) {
                    this.dialogTitle = "编辑合作商";
                    this.form = Object.assign({}, row);
                } else {
                    this.dialogTitle = "新增合作商";
                    this.form = {
                        id: null,
                        itemId: null,
                        itemName: "",
                        unitName: "",
                        contactPerson: "",
                        post: "",
                        phone: "",
                        wechat: "",
                        cooperationMatters: ""
                    };
                }
            })
        },
        submitForm() {
            if (this.form.id) {
                //编辑
                this.$axios.post(this.$httpUrl + "/cooperation/update", this.form).then(res => res.data).then(res => {
                    if (res.code === 200) {
                        this.$message.success("编辑成功");
                        this.dialogVisible = false;
                        this.loadPost();
                    }
                })
            } else {
                //新增
                this.$axios.post(this.$httpUrl + "/cooperation/add", this.form).then(res => res.data).then(res => {
                    if (res.code === 200) {
                        this.$message.success("新增成功");
                        this.dialogVisible = false;
                        this.loadPost();
                    }
                })
            }
        },
        // 适配popconfirm，只接收id
        handleDelete(id) {
            this.$axios.get(this.$httpUrl + "/cooperation/del?id=" + id).then(res => res.data).then(res => {
                if (res.code === 200) {
                    this.$message.success("删除成功");
                    this.loadPost();
                } else {
                    this.$message.error("删除失败");
                }
            })
        },
        handleItemChange(itemId) {
            if (!itemId) {
                this.form.itemName = "";
                return;
            }
            const selected = this.itemOptions.find(x => x.id === itemId)
            if (selected) {
                this.form.itemName = selected.name
            }
        }
    },
    beforeMount() {
        this.loadPost();
    }
}
</script>
<style scoped>
.cooperation-manage {
  padding: 20px;
  background: #f5f7fa;
  min-height: 100vh;
}

.search-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
  background: #fff;
  padding: 16px 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.search-fields {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.action-btn {
  font-size: 14px;
  border-radius: 8px;
  padding: 8px 16px;
}

.action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding: 16px 0;
}

.el-table {
  border-radius: 12px;
  overflow: hidden;
}

.el-table th.el-table__cell {
  background-color: #f8f9fc !important;
}

.el-dialog__body {
  padding: 20px 30px;
}

.el-form-item__label {
  font-weight: 500;
  color: #2c3e50;
}
</style>